export default { 
  partida: null,
  index: null,
}